import { Logger } from "@daytrip/logger";

import { ENVIRONMENT } from "./config.management";

export const globalManagementLogger = new Logger({
    app: "management",
    env: ENVIRONMENT,
});
